'use strict';

import React, { Component } from 'react';
import { render } from 'react-dom';
// const $ = window.$;
import redirectURL from '../redirectURL';
var googleAnalytics = require("../common/googleanalytics");

export default class LandingDashboard extends Component {
  constructor(props) {
    super(props);
      this.state = {
        biURL:""
        //components : {datepicker:getDatePicker()}
    }
  }

  componentDidMount() {
    redirectURL.post("/powerbi/getPowerBIURL")
      .then(response => response.data.output)  // Extract output directly from response
      .then(output => {
        if (output.length > 0) {
          this.setState({
            biURL: output[0].powerbi
          });
        }
      })
      .catch(error => {
        console.error("Error fetching PowerBI URL:", error);
      });
  }


 
  render() {
    return (
      <div class="container-fluid">
        <div className="card col-xl-12">
          
            <div className="card-body col-xl-12 col-lg-12">
              {this.state.biURL &&

                <iframe 
                  style={{overflow:"hidden",border:"0px", margin:"0px", width:"100%", height:"100vh"}} 
                  width="100%" 
                  frameborder="0"
                  height="100vh"
                  allowFullScreen="true" 
                  src={this.state.biURL}>
                  
              </iframe>
              }

               
            </div>
        </div>
      </div>

    );
  }
}